import React from "react";
import "../../style/studentForm.css";

export default function StudentRegistrationForm() {
  return (
    <form id="practiceForm" className="student-form">
      <h1 className="form-title">Student Registration Form</h1>

      <div className="form-row">
        <label htmlFor="name">Name:</label>
        <input id="name" name="name" type="text" placeholder="First Name" required />
      </div>

      <div className="form-row">
        <label htmlFor="email">Email:</label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="name@example.com"
          required
        />
      </div>

      <div className="form-row">
        <label>Gender:</label>
        <div className="radio-group">
          <label>
            <input type="radio" name="gender" required /> Male
          </label>
          <label>
            <input type="radio" name="gender" /> Female
          </label>
          <label>
            <input type="radio" name="gender" /> Other
          </label>
        </div>
      </div>

      <div className="form-row">
        <label htmlFor="mobile">Mobile (10 Digits):</label>
        <input
          id="mobile"
          name="mobile"
          type="tel"
          pattern="[0-9]{10}"
          placeholder="Enter Mobile Number"
          required
        />
      </div>

      <div className="form-row">
        <label htmlFor="dob">Date of Birth:</label>
        <input id="dob" name="dob" type="date" required />
      </div>

      <div className="form-row">
        <label htmlFor="subjects">Subjects:</label>
        <input
          id="subjects"
          name="subjects"
          type="text"
          placeholder="Enter Subject"
          required
        />
      </div>

      <div className="form-row">
        <label>Hobbies:</label>
        <div className="checkbox-group">
          <label>
            <input type="checkbox" required /> Sports
          </label>
          <label>
            <input type="checkbox" /> Reading
          </label>
          <label>
            <input type="checkbox" /> Music
          </label>
        </div>
      </div>

      <div className="form-row">
        <label htmlFor="picture">Picture:</label>
        <input id="picture" name="picture" type="file" required />
      </div>

      {/* NOT REQUIRED */}
      <div className="form-row">
        <label htmlFor="address">Current Address:</label>
        <textarea id="address" placeholder="Current Address"></textarea>
      </div>

      <div className="form-row">
        <label>State and City</label>
        <div className="state-city">
          <select name="state" required>
            <option value="">Choose State</option>
            <option value="NCR">NCR</option>
            <option value="Uttar Pradesh">Uttar Pradesh</option>
            <option value="Haryana">Haryana</option>
            <option value="Rajasthan">Rajasthan</option>
          </select>

          <select name="city" required>
            <option value="">Choose City</option>
            <option value="Agra">Agra</option>
            <option value="Lucknow">Lucknow</option>
            <option value="Meerut">Meerut</option>
          </select>
        </div>
      </div>

      <div className="submit-row">
        <input type="submit" value="Submit" className="submit-btn" />
      </div>
    </form>
  );
}